import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";

// Helpers
import { localCurrency } from "@/plugins/currency";

// External components
import SubscriptionStatusBadge from "../subscriptionStatusBadge/subscriptionStatusBadge";

@Component({ components: { SubscriptionStatusBadge }, methods: { localCurrency, moment } })
export default class OrdersHistoryCard extends Vue {
  @Prop({ default: null }) order;
}
